import { BaseFieldRenderer } from './base-field-renderer';
import { NumberFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class NumberFieldRenderer extends BaseFieldRenderer<NumberFieldJsonData> {
    protected override get defaultData(): NumberFieldJsonData {
        return {
            id: '',
            type: 'number',
            label: TranslateUtils.NUMBER_FIELD.LABEL,
            placeholder: TranslateUtils.NUMBER_FIELD.PLACEHOLDER,
            required: false,
            hiddenLabel: false
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderInput(fieldJsonData: NumberFieldJsonData, options: RenderOptions): HTMLElement {
        const input = document.createElement('input');
        input.classList.add('input', 'default');
        input.type = 'text';

        this.applyCommonAttributes(input, fieldJsonData);

        return input;
    }
}
